const env = process.env.REACT_APP_ENV;
const config = {
  backend_url: null,
  twitter_oauth_url: null,
};
if (env === "prod") {
  config.backend_url = "https://nazocon-api.herokuapp.com/api/";
  config.twitter_oauth_url = "http://nazocon-oauth.herokuapp.com/twitter/oauth";
  config.google_oauth_url = "http://nazocon-oauth.herokuapp.com/google/oauth2";
} else if (env === "stage") {
  config.backend_url = "https://nazocon-api-stage.herokuapp.com/api/";
  config.twitter_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/twitter/oauth";
  config.google_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/google/oauth2";
} else if (env === "local") {
  config.backend_url = "https://nazocon-api-stage.herokuapp.com/api/";
  config.twitter_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/twitter/oauth";
  config.google_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/google/oauth2";
} else {
  config.backend_url = "https://nazocon-api-stage.herokuapp.com/api/";
  config.twitter_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/twitter/oauth";
  config.google_oauth_url = "http://nazocon-oauth-stage.herokuapp.com/google/oauth2";
}
window.console.log("Loaded config for " + env);
window.console.log(config);
export default config;
